import axios from "axios";
import { baseUrlOtodis, xApiKeyOtodis } from "../../config/api/apiConfig";

class OrderApiService {
  private axios = axios.create({
    baseURL: baseUrlOtodis,
  });

  public setToken(token: string) {
    this.axios.defaults.headers.common["Authorization"] = "Bearer " + token;
  }

  public async getOrder(params?: any) {
    const queries = {
      ...(params?.dealerCode && {
        dealer_code: params.dealerCode,
      }),
      ...(params?.orderCode && {
        order_code: params.orderCode,
      }),
      ...(params?.dataType && {
        date_type: params.dataType,
      }),
      ...(params?.dateStart && {
        date_start: params.dateStart,
      }),
      ...(params?.dateEnd && {
        date_end: params.dateEnd,
      }),
      ...(params?.statusOrder && {
        status: params.statusOrder,
      }),
      ...(params?.vehicleEngineNumber && {
        vehicle_engine_number: params.vehicleEngineNumber,
      }),
      ...(params?.transferTitleStatus && {
        transfer_title_status: params.transferTitleStatus,
      }),
      ...(params?.handoverStatus && {
        handover_status: params.handoverStatus,
      }),
    };
    try {
      return await this.axios.get<any>("/order", {
        headers: {
          "X-Api-Key": xApiKeyOtodis,
        },
        params: {
          ...queries,
        },
      });
    } catch (e: any) {
      throw new Error(e);
    }
  }

  public async createOrder(inputData?: any) {
    try {
      return await this.axios.post<any>("/order", inputData, {
        headers: {
          "X-Api-Key": xApiKeyOtodis,
          "Content-Type": "application/json",
        },
      });
    } catch (e: any) {
      console.log(e);
      throw new Error(e);
    }
  }

  public async assignServiceBureau(inputData?: any) {
    try {
      return await this.axios.post<any>("/order/assign-service-bureau", inputData, {
        headers: {
          "X-Api-Key": xApiKeyOtodis,
          "Content-Type": "application/json",
        },
      });
    } catch (e: any) {
      console.log(e);
      throw new Error(e.response.data.error.message);
    }
  }

  public async cancelOrder(inputData?: any) {
    try {
      return await this.axios.put<any>("/order/cancel", inputData, {
        headers: {
          "X-Api-Key": xApiKeyOtodis,
          "Content-Type": "application/json",
        },
      });
    } catch (e: any) {
      console.log(e);
      throw new Error(e);
    }
  }

  public async returOrder(inputData?: any) {
    try {
      return await this.axios.delete<any>("/order/retur", {
        headers: {
          "X-Api-Key": xApiKeyOtodis,
          "Content-Type": "application/json",
        },
        data: inputData,
      });
    } catch (e: any) {
      throw new Error(e.response.data.message);
    }
  }

  public async getTransferTaxControl(params?: any) {
    const queries = {
      ...(params?.serviceBureauCode && {
        service_bureau_code: params.serviceBureauCode,
      }),
      ...(params?.startDate && {
        date_start: params.startDate,
      }),
      ...(params?.endDate && {
        date_end: params.endDate,
      }),
      ...(params?.transferTitleStatus && {
        transfer_title_status: params.transferTitleStatus,
      }),
      ...(params?.dealerCode && {
        dealer_code: params.dealerCode,
      }),
      ...(params?.vehicleEngineNumber && {
        vehicle_engine_number: params.vehicleEngineNumber,
      }),
      ...(params?.noticeUploaded !== undefined && {
        notice_uploaded: params.noticeUploaded,
      }),
    };
    try {
      return await this.axios.get<any>("/order/assigned-service-bureau", {
        headers: {
          "X-Api-Key": xApiKeyOtodis,
        },
        params: {
          ...queries,
        },
      });
    } catch (e: any) {
      throw new Error(e);
    }
  }

  public async CancelDeliveryOrder(params?: { dealerCode?: any; orderCode?: any }) {
    try {
      return await this.axios.delete<any>(`/order/delivery?dealer_code=${encodeURIComponent(params?.dealerCode)}&order_code=${encodeURIComponent(params?.orderCode)}`, {
        headers: {
          "X-Api-Key": xApiKeyOtodis,
          "Content-Type": "application/json",
        },
      });
    } catch (e: any) {
      console.log(e);
      throw new Error(e.response.data.message);
    }
  }
}

export const orderApiService = new OrderApiService();
